import { routes } from './routes.js'

/**
 * 根据每个.vue页面下同名的json/js文件，来配置路由
 * 优先查找同名的json文件，没有的话再查找js文件，还是没有就给个默认的配置
 * component或components目录下的.vue不会被认为是页面，不会加到路由里
 *
 * json文件内容格式
 * {
    "route": {
        "path": "/user/login",  # 当时某个子路由时，可以去掉前面的/，视为相对路径, 没有则会根据目录未知设置路径
        "hidden": true,
        "component": "@/pages/xxx"  # 组件路径
        "meta": {
            "title": "登录",
            "auth": "public", # 权限： public-公共；sign-需要登录
            "parent": "key", # 父级的key，当有这个值时，视为该key对应的子路由
            "key": "key"  # 要唯一
            "sort": 100  # 排序，升序，有些路由需要特定的排序，比如404要放在最后，不填时默认为0
        },
        "children": [
        ]
    }
  }
 * js文件内容格式（数据结构和json的相同）
 * export default {
    route: {
        hidden: true,
        meta: {
            title: '文件管理',
            auth: "sign",
            parent: "basic_layout"
        }
    }
  }
 */
/**
 * myRoutes
 * 配置文件里没有的路由，可以加到routes里去
 */
 var myRoutes = routes

const files = require.context('@/pages/', true, /\.(vue|json|js)$/)

const vueReg = RegExp(/\.vue$/)
const componentReg = RegExp(/component/)
const appReg = RegExp(/App.vue/)
const pathKeys = files.keys()
var waitRoutes = {}
pathKeys.forEach(key=> {
  // 不是.vue文件或者路径上有component的视为子组件，跳过
  if (!key.match(vueReg) || key.match(componentReg) || key.match(appReg)) {
    return
  }
  let route
  // 找有没有对应的json文件
  const jsonKey = key.replace(/.vue$/, ".json")
  if (pathKeys.indexOf(jsonKey) !== -1) {
    // 先找json文件
    const jsonData = files(jsonKey)
    route = jsonData.route
  } else {
    // 再找js文件
    const jsKey = key.replace(/.vue$/, ".js")
    if (pathKeys.indexOf(jsKey) !== -1
      && Object.prototype.toString.call(files(jsKey).default) === '[object Object]'
      && files(jsKey).default.route) {
      route = files(jsKey).default.route
    } else {
      // 都没有，给个默认的值
      route = {
        //path: path,
        //component: files(key).default,
        hidden: true,
      }
    }
  }

  if (!("path" in route)) {
    const path = key.replace(/(^\.|(\/[^\/]*$))/g, "")
    if (path === "") {
      return
    }
    route.path = path
  }
  route.component = files(key).default

  // 子路由
  if (route.children && route.children.length > 0) {
    generateRoutes(route.children)
  }

  if (route.meta.parent) {
    const parent = route.meta.parent
    // 有父级路由，先存起来
    waitRoutes[parent] ? waitRoutes[parent].push(route) : (waitRoutes[parent] = [ route ])
  } else {
    // 没有父级路由，直接怼进去
    myRoutes.push(route)
  }
})

generateRoutesByWait(myRoutes)

myRoutes = sortRoutes(myRoutes)

console.log(myRoutes)

export default myRoutes


// 查找waitRoutes里有没有子路由，并加入路由里
function generateRoutesByWait (routes) {
  for (var i = 0; i < routes.length; i++) {
    if (!routes[i].meta || !routes[i].meta.key) {
      continue
    }

    const key = routes[i].meta.key
    if (waitRoutes[key]) {
      routes[i].children = routes[i].children ? routes[i].children.concat(waitRoutes[key]) : waitRoutes[key]
      delete waitRoutes[key]
      if (Object.keys(waitRoutes).length === 0) {
        return
      }
      generateRoutesByWait(routes[i].children)
    }
  }
}

// 根据数据生成路由
function generateRoutes (routes) {
  for (var i = 0; i < routes.length; i++) {
    if (routes[i].component) {
      // 改造成需要的key，用于从files里查找对应的file
      const component = routes[i].component
      var key = component.replace(/^@\/pages\//g, './')
      if (key.indexOf('/') === 0) {
        key = '.' + key
      }
      if (key.indexOf('./') !== 0) {
        key = './' + key
      }
      if (!key.match(vueReg)) {
        key += '.vue'
      }

      routes[i].component = files(key).default
    }

    if (routes[i].children && routes[i].children.length > 0) {
      generateRoutes(routes[i].children)
    }
  }
}

// 排序路由，有些路由需要做排序。比如404要放在最后
function sortRoutes (routes) {
  if (!routes || routes.length === 0) {
    return routes
  }
  for (let index in routes) {
    routes[index].children = sortRoutes(routes[index].children)
  }
  return routes.sort(function(a, b) {
    let aSort = (a.meta && a.meta.sort) ? a.meta.sort : 0
    let bSort = (b.meta && b.meta.sort) ? b.meta.sort : 0
    return aSort - bSort
  })
}
